import React from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      <main>
        <section className="hero-section">
          <div className="hero-image">
            <img src="/main/main1.webp" alt="A New Chapter" />
          </div>
          <div className="hero-content">
            <p className="hero-subtitle">Fresh pieces, softly refined</p>
            <h1 className="hero-title">A New Chapter</h1>
            <Link to="/shop" className="hero-btn" onClick={toTop}>
              SHOP NOW
            </Link>
          </div>
        </section>

        <section className="celestial-section">
          <div className="celestial-header">
            <h2 className="celestial-title">Celestial Touch</h2>
            <p className="celestial-text">
              Inspired by the stars, made for dreamers and stargazers at heart.
              Drawing on the mysteries of the cosmos, each piece is a wearable
              constellation — a gentle connection to the celestial wonders that
              have inspired humanity for centuries.
            </p>
          </div>
          <div className="categories-grid">
            <Link to="/shop" className="category-card" onClick={toTop}>
              <img src="/main/main2-1.webp" alt="Earrings" />
              <span className="category-name">Earrings</span>
            </Link>
            <Link to="/shop" className="category-card" onClick={toTop}>
              <img src="/main/main2-2.webp" alt="Necklaces" />
              <span className="category-name">Necklaces</span>
            </Link>
            <Link to="/shop" className="category-card" onClick={toTop}>
              <img src="/main/main2-3.webp" alt="Bracelets" />
              <span className="category-name">Bracelets</span>
            </Link>
            <Link to="/shop" className="category-card" onClick={toTop}>
              <img src="/main/main2-4.webp" alt="Rings" />
              <span className="category-name">Rings</span>
            </Link>
          </div>
        </section>

        <section className="products-section">
          <Link to="/shop" className="view-all-link" onClick={toTop}>
            View all
          </Link>
          <div className="products-grid">
            {productData.slice(0, 4).map((product) => (
              <Link
                to={`/shopDetails/${product.id}`}
                key={product.id}
                className="product-card"
                onClick={toTop}
              >
                <div className="product-image">
                  <img src={product.image} alt={product.name} />
                </div>
                <div className="product-info1">
                  <h3 className="product-name">{product.name}</h3>
                  <p className="product-price">€{product.price}</p>
                </div>
              </Link>
            ))}
          </div>
        </section>

        <section className="second-hero">
          <img src="/main/main3.webp" alt="Jewels Born of Earth & Sky" />
          <div className="second-hero-content">
            <h2 className="second-hero-title">Jewels Born of Earth & Sky</h2>
            <p className="second-hero-text">
              Jewellery shaped by hand, guided by nature, and kissed by the
              light of sun and moon.
            </p>
          </div>
        </section>

        <section className="collections-section">
          <div className="collections-grid">
            <div className="collection-card">
              <img src="/main/main4-1.webp" alt="Wild Horizon" />
              <span className="collection-name">Wild Horizon</span>
            </div>
            <div className="collection-card">
              <img src="/main/main4-2.webp" alt="Celestial" />
              <span className="collection-name">Celestial</span>
            </div>
            <div className="collection-card">
              <img src="/main/main4-3.webp" alt="Gothics" />
              <span className="collection-name">Gothics</span>
            </div>
          </div>
        </section>

        <section className="testimonials-section">
          <div className="testimonials-container">
            <div className="testimonial active">
              <div className="stars">★★★★★</div>
              <p className="testimonial-text">
                At mefurvexo, small forms carry the story: a curved line, a
                polished surface, or a stone chosen for its natural colour.
                Each piece is designed to feel expressive without being hard to
                wear, with details that reveal themselves from every angle.
              </p>
              <p className="testimonial-author">mefurvexo design notes</p>
            </div>
          </div>
        </section>

        <section className="store-section">
          <div className="store-image">
            <img src="/main/main5.webp" alt="mefurvexo online studio" />
          </div>
          <div className="store-info">
            <h3 className="store-title">Online Studio</h3>
            <p className="store-address">
              Browse the collection online, wherever you are.
            </p>
            <div className="store-hours">
              <p>Customer care: Monday–Friday</p>
              <p>Order enquiries: email anytime</p>
            </div>
            <p className="store-note">
              We reply as soon as possible during customer-care days.
            </p>
            <Link to="/contact" className="directions-btn" onClick={toTop}>Contact us</Link>
          </div>
        </section>

        <section className="features-section">
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon">✦</div>
              <h4 className="feature-title">Made for Everyday</h4>
              <p className="feature-text">
                Versatile proportions and secure closures make these pieces
                easy to include in your everyday rotation.
              </p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">✦</div>
              <h4 className="feature-title">Thoughtful Materials</h4>
              <p className="feature-text">
                Material details are stated clearly on every product page so
                you can choose the finish that suits you.
              </p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">✦</div>
              <h4 className="feature-title">Clear Product Details</h4>
              <p className="feature-text">
                Each listing describes its metal, stones, closure, and care
                guidance in straightforward language.
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Main;
